/* 0.46.99 - Pages and flows that only signed-in visitors may see
 * (Requires login). The server answers 401 "login_required" to anyone
 * else; the site then goes to the login page, which brings the visitor
 * back here after signing in (?next=). */
export function isLoginRequired(err) {
  return !!err && err.status === 401
    && (err.message === 'login_required' || (err.body && err.body.detail === 'login_required'));
}

export function goToLogin(navigate, location) {
  const here = `${location.pathname}${location.search || ''}`;
  navigate(`/login?next=${encodeURIComponent(here)}`, { replace: true });
}
